import { handleActions } from 'redux-actions';
import { Actions, getThemeHistoryFailure, getThemeHistorySuccess } from 'actions/themeHistoryActions';
import { DeviceId, ThemeHistory } from 'shared/models';
import { omit } from 'lodash';
import { Actions as SessionActions, logoutSuccess } from "../actions/sessionActions";
import { Actions as CheckInsActions, getCheckInsRequest } from "../actions/checkInsActions";

export type State = Readonly<{
    data: Record<DeviceId, ThemeHistory>;
    loading: Record<DeviceId, boolean>;
    errors: Record<DeviceId, Error>;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: {},
    errors: {},
});

export const themeHistoryReducer = handleActions({
    [CheckInsActions.GET_CHECKINS_REQUEST]: (state: State, action: ReturnType<typeof getCheckInsRequest>) => {
        const deviceId = action.payload;
        return {
            ...state,
            loading: {
                ...state.loading,
                [deviceId]: true,
            },
        };
    },

    [Actions.GET_THEME_HISTORY_SUCCESS]: (state: State, action: ReturnType<typeof getThemeHistorySuccess>) => {
        const themeHistory = action.payload;
        const { deviceId } = action.meta;
        const { data, loading, errors } = state;

        return {
            ...state,
            data: {
                ...data,
                [deviceId]: themeHistory,
            },
            loading: {
                ...loading,
                [deviceId]: false,
            },
            errors: omit(errors, deviceId),
        };
    },

    [Actions.GET_THEME_HISTORY_FAILURE]: (state: State, action: ReturnType<typeof getThemeHistoryFailure>) => {
        const { deviceId } = action.meta;
        return {
            ...state,
            loading: {
                ...state.loading,
                [deviceId]: false,
            },
            errors: {
                ...state.errors,
                [deviceId]: action.payload,
            },
        };
    },

    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: (state: State, action: ReturnType<typeof logoutSuccess>) => {
        return initialState;
    },
} as any, initialState);
